import { createSelector } from 'reselect';

const selectSettlementItems = (state: any) => state.settlementItems;


export const selectSettlementItemCurrentItem = createSelector([selectSettlementItems], (settlementItems) => settlementItems.current);

export const selectSettlementItemsListItems = createSelector([selectSettlementItems], (settlementItems) => settlementItems.list);

export const selectSettlementItemItemById = (itemId: any) =>
    createSelector(selectSettlementItemsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectSettlementItemQueryItems = createSelector([selectSettlementItems], (settlementItems) => settlementItems.query);

export const selectSettlementItemCreatedItem = createSelector([selectSettlementItems], (settlementItems) => settlementItems.create);

export const selectSettlementItemUpdatedItem = createSelector([selectSettlementItems], (settlementItems) => settlementItems.update);

export const selectSettlementItemReadItem = createSelector([selectSettlementItems], (settlementItems) => settlementItems.read);

export const selectSettlementItemDeletedItem = createSelector([selectSettlementItems], (settlementItems) => settlementItems.delete);

export const selectSettlementItemSearchedItems = createSelector([selectSettlementItems], (settlementItems) => settlementItems.search);

export const selectSettlementItemItemsCount = createSelector([selectSettlementItems], (settlementItems) => settlementItems.count);

export const selectSettlementItemItemsFilter = createSelector([selectSettlementItems], (settlementItems) => settlementItems.filter);